/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMfrmBestForSleepStylesViewProps } from './mfrm-best-for-sleep-styles';
import { TitleListAbout } from '../mfrm-helps-with-sleep-disruptors/mfrm-helps-with-sleep-disruptors.view';

export default (props: IMfrmBestForSleepStylesViewProps) => {
    const {
        data: {
            productSpecificationData: { result }
        },
        config: { titleHeadingTag, sleepStyle, aboutLink, sleepStyleOptions }
    } = props;
    const sleepPosition = result && sleepStyle
        ? result.find(obj => obj.Name && obj.Name.toLowerCase().trim() === sleepStyle.toLowerCase().trim())?.TextValue
        : undefined;
    const sleepDisplayNameOptions = sleepStyleOptions?.find(option => option.selectedSleepStyle === sleepPosition);
    if (sleepPosition && sleepPosition !== 'NO') {
        return (
            <TitleListAbout
                title={titleHeadingTag}
                list={[sleepDisplayNameOptions?.sleepStyleDisplayName]}
                linkHref={aboutLink?.linkUrl.destinationUrl}
                linkAreaLabel={aboutLink?.ariaLabel}
                linkText={aboutLink?.linkText}
            />
        );
    } else {
        return (<>
        </>);
    }
};


